import React, {useState} from 'react'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'
import Page from 'attendee/theme/Page'
import AttendeeTransactions from 'attendee/Invoices/Transactions'
import CreateInvoiceModal from 'attendee/Invoices/Transactions/CreateInvoiceModal'
import AttendeeCompanyUpdate from 'attendee/Invoices/Companies/AttendeeCompanyUpdate'
import AttendeeInvoices from 'attendee/Invoices/Invoices'

type TabKey = 'companies' | 'invoices' | 'transactions'

export function Invoices() {
  const {t} = useI18n()
  const [tab, setTab] = useState<TabKey>('invoices')

  return (
    <Page
      modals={
        <>
          <CreateInvoiceModal />
        </>
      }
    >
      <>
        <section className="event__schedule-area dark_light_class pt-55 pb-150">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xxl-7 col-xl-7 col-lg-6">
                <h2 className="section__title mb-35">
                  {t('attendeeInvoices.pageTitleBefore')}{' '}
                  <span className="text__highlight">
                    {t('attendeeInvoices.pageTitleHighlight')}
                  </span>
                </h2>
              </div>

              <Tabs>
                <TabButton
                  $active={tab === 'invoices'}
                  onClick={() => setTab('invoices')}
                >
                  {t('attendeeInvoices.tabInvoices')}
                </TabButton>
                <TabButton
                  $active={tab === 'transactions'}
                  onClick={() => setTab('transactions')}
                >
                  {t('attendeeInvoices.tabTransactions')}
                </TabButton>
                <TabButton
                  $active={tab === 'companies'}
                  onClick={() => setTab('companies')}
                >
                  {t('attendeeInvoices.tabCompany')}
                </TabButton>
              </Tabs>
              {tab === 'invoices' && <AttendeeInvoices />}
              {tab === 'transactions' && <AttendeeTransactions />}
              {tab === 'companies' && <AttendeeCompanyUpdate />}
            </div>
          </div>
        </section>
      </>
    </Page>
  )
}

const Tabs = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 18px 0 18px;
`

const TabButton = styled.button<{$active: boolean}>`
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid ${({$active}) => ($active ? '#f7426f' : '#e6e6e6')};
  background: ${({$active}) => ($active ? 'rgba(247,66,111,0.08)' : '#fff')};
  font-weight: 600;
  cursor: pointer;
`
